import React, { Component } from 'react';
import { FormGroup, Input, Col, Row, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import CounterInput from '../../components/reusable/CounterInput';
import ModalReemplazo from '../../components/reusable/modals/Reemplazar';
import product from '../../assets/img/product.png';
import c from '../../constants/Colors';
import localStorageCustom from '../../utilitarios/localStorage';
import { data } from '../../constants/Constants';
import { notificacion, getStatePage } from '../../utilitarios/util';
import { AgregarProductoFavorito } from '../../store/sagas/favoritoApi';
import { BuscarPedidoMasivo } from '../../store/sagas/pedidoApi';
import { AgregarNuevoProductoPedidoMasivo, AgregarProductoPedidoMasivo, ListarMaterialSustituto } from '../../store/sagas/carritoApi';
import { BuscarKit } from '../../store/sagas/pedidoApi';
import { AuthContext } from "../../store/provider/AuthProvider";
import CardPrecios from "../reusable/CardPrecios";
import ModalImageZoom from '../reusable/modals/ImageZoom';
import ModalKit from '../reusable/modals/kit';
import Spinner from "../reusable/Loader";

const Pills = ({ dadComponent }) => {
  let { pillActive } = dadComponent.state;
  return (
    <button className='tab-pills-xs' onClick={() => dadComponent.switchPill()}>
      <div className={`pill ${pillActive == 0 ? "active" : ''}`}>
        <SvgAssets icon="icon-list-2" fill={pillActive == 0 ? c.azulClaro : c.celeste} />
      </div>
      <div className={`pill ${pillActive == 1 ? "active" : ''}`}>
        <SvgAssets icon="icon-table" fill={pillActive == 1 ? c.azulClaro : c.celeste} />
      </div>
    </button>
  )
}

const Productos = ({ dadComponent, producto }) => {
  let { setCounter, postEliminarBuscador, state } = dadComponent;
  let { pillActive } = state;
  if (pillActive == 0) {
    return (
      <div className="card_listado">
        <Row form>
          <Col xs={3} md={3} className="pr-0" style={{ alignSelf: 'center' }}>
            <span className="paragraph-3 desktop_parrafo2 bold verde">{producto.matnr}</span>
          </Col>
          <Col xs={2} md={3} style={{ alignSelf: 'center' }}>
            {/* <CounterInput
              vertical
              background={"#fff"}
              color={"#316ACD"}
              borderColor={"#E2E2E2"}
              data={producto}
              eventCounter={setCounter}
            /> */}
            <span className="paragraph-3 bold">{producto.cantidad}</span>
          </Col>
          <Col xs={5} md={4} style={{ alignSelf: 'center' }}>
            <CardPrecios data={producto.precios} escalas={producto.escalas} cantidad={producto.cantidad} className="cardPrice" />
          </Col>
          <Col xs={2} md={2} style={{ alignSelf: 'center' }}>
            {/* <button className="btn-icon" type="button"
              onClick={() => postEliminarBuscador(producto.indice)}
            >
              <SvgAssets icon="icon-trash" fill={c.celeste} />
            </button> */}
            {producto.flagKit ? (
              <button className='btn-icon m-auto' onClick={() => dadComponent.toggleModalKit(producto.matnr, producto.maktx)}>
                <SvgAssets icon="icon-kit" fill={'#ED7F9A'} />
              </button>) : ''}
          </Col>
        </Row>

      </div>
    )
  } else {
    return (
      <div className="card_product_vertical card_pedido_masivo">
        <div style={{ cursor: 'pointer', alignSelf: 'center' }} onClick={() => dadComponent.toggleModalZoom(producto.pathImage)}>
          <img className="product-img" src={producto.pathImage} />
        </div>
        <div className="content">
          <h6 className="paragraph-2 bold verde">{producto.maktx}</h6>
          <span className="paragraph-3 sku">SKU: {producto.matnr}</span>
          <CardPrecios data={producto.precios} escalas={producto.escalas} cantidad={producto.cantidad} className="cardPrice" />
          <div className="counter align-items-center justify-content-between">
            {/* <CounterInput
              background={"#fff"}
              color={"#316ACD"}
              borderColor={"#E2E2E2"}
              data={producto}
              eventCounter={dadComponent.setCounter}
            /> */}

            <span className="paragraph-3 bold">Cant. {producto.cantidad}</span>
            {producto.flagKit ? (
              <button className='btn-icon' onClick={() => dadComponent.toggleModalKit(producto.matnr, producto.maktx)}>
                <SvgAssets icon="icon-kit" fill={'#ED7F9A'} />
              </button>) : ''}
            {/* <button className="btn-icon" type="button"
              onClick={() => postEliminarBuscador(producto.indice)}
            >
              <SvgAssets icon="icon-trash" fill={c.celeste} />
            </button> */}
          </div>
        </div>
      </div>
    )
  }
}

const ProductosSinStock = ({ dadComponent, producto }) => {
  let { setCounter, MostrarReemplazo, postAgregarProductoFavorito, state } = dadComponent;
  let { pillActive } = state;
  if (pillActive == 0) {
    return (
      <div className="card_listado">
        <Row form>
          <Col xs={3} md={3} className="pr-0" style={{ alignSelf: 'center' }}>
            <span className="paragraph-3 desktop_parrafo2  bold rojo">{producto.matnr}</span>
          </Col>
          <Col xs={2} md={3} style={{ alignSelf: 'center' }}>
            {/* <CounterInput
              vertical
              background={"#fff"}
              color={"#316ACD"}
              borderColor={"#E2E2E2"}
              data={producto}
              eventCounter={setCounter}
            /> */}
            <span className="paragraph-3 bold">{producto.cantidad}</span>
          </Col>
          <Col xs={5} md={4} style={{ alignSelf: 'center' }}>
            <CardPrecios data={producto.precios} escalas={producto.escalas} cantidad={producto.cantidad} className="cardPrice" />
          </Col>
          <Col xs={2} md={2} >
            <div className="options">
              {producto.flagKit ? (
                <button className='btn-icon' onClick={() => dadComponent.toggleModalKit(producto.matnr, producto.maktx)}>
                  <SvgAssets icon="icon-kit" fill={'#ED7F9A'} />
                </button>) : ''}
              <button className="btn-icon" type="button"
                onClick={() => postAgregarProductoFavorito({
                  codigo: producto.matnr, descripcion: producto.maktx,
                  moneda: producto.waers, pantalla: data.Pantalla.BuscarMasivo.Producto
                }, producto.favorito, producto.indice)}>
                <SvgAssets icon="icon-star" fill={producto.favorito ? c.amarillo : c.celeste} />
              </button>
              {/* {(producto.sustituto) ?
                <button className="btn-icon" type="button"
                  onClick={() => MostrarReemplazo(producto)}>
                  <SvgAssets icon="icon-foco" />
                </button>
                : null} */}
            </div>
          </Col>
        </Row>
      </div>
    )
  } else {
    return (
      <div className="card_product_vertical card_pedido_masivo">
        <div style={{ cursor: 'pointer', alignSelf: 'center' }} onClick={() => dadComponent.toggleModalZoom(producto.pathImage)}>
          <img className="product-img" src={producto.pathImage} />
        </div>
        <div className="content">
          <h6 className="paragraph-2 bold verde">{producto.maktx}</h6>
          <span className="paragraph-3 sku">SKU: {producto.matnr}</span>
          <CardPrecios data={producto.precios} escalas={producto.escalas} cantidad={producto.cantidad} className="cardPrice" />
          <div className="counter align-items-center justify-content-between">
            {/* <CounterInput
              background={"#fff"}
              color={"#316ACD"}
              borderColor={"#E2E2E2"}
              data={producto}
              eventCounter={dadComponent.setCounter}
            /> */}
            <span className="paragraph-3 bold mb-0">Cant. {producto.cantidad}</span>
            {producto.flagKit ? (
              <button className='btn-icon' onClick={() => dadComponent.toggleModalKit(producto.matnr, producto.maktx)}>
                <SvgAssets icon="icon-kit" fill={'#ED7F9A'} />
              </button>) : ''}
          </div>
          <div className="options mt-2">
            <button className="btn-icon" type="button"
              onClick={() => postAgregarProductoFavorito({
                codigo: producto.matnr, descripcion: producto.maktx,
                moneda: producto.waers, pantalla: data.Pantalla.BuscarMasivo.Producto
              }, producto.favorito, producto.indice)}>
              <SvgAssets icon="icon-star" fill={producto.favorito ? c.amarillo : c.celeste} />
            </button>
            {(producto.sustituto) ?
              <button className="btn-icon" type="button"
                onClick={() => MostrarReemplazo(producto)}
              >
                <SvgAssets icon="icon-foco" />
              </button>
              : null}
          </div>
        </div>
      </div>
    )
  }
}

export class PedidoMasivo extends Component {
  static displayName = PedidoMasivo.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      pillActive: 0,
      showDetails: false,
      showModalReemplazar: false,
      pedidoMasivo: [],
      alertas: [],
      dealer: {},
      linea: {},
      asociado: {},
      page: 1,
      size: data.PageSize,
      currentPage: 1,
      dataReemplazo: {
        data: [],
        isVisible: false,
        producto: null
      },
      productoReem: {
        cantidad: 0
      },
      modalZoom: false,
      modalKit: false,
      imgZoom: "",
      detalleKit: [],
      kit: '',
    };
  }
  checkParams() {
    const { state } = this.props.location;
    if (state) {
      let datosBuscador = state.datosBuscador;
      this.setState({ pedidoMasivo: datosBuscador.pedidoMasivo, alertas: datosBuscador.alertas })
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }
  toggleModalZoom = (img) => {
    this.setState(prevState => ({
      modalZoom: !prevState.modalZoom,
      imgZoom: img
    }));
  }
  toggleModalKit = (matnr, maktx) => {
    this.setState(prevState => ({
      modalKit: !prevState.modalKit,
    }));
    if (!this.state.modalKit) {
      this.setState(prevState => ({
        kit: maktx,
      }));
      this.postBuscarKit(this.state.dealer, this.state.linea, matnr)
    }
  }

  componentDidMount() {
    if (getStatePage(this.props)) {
      window.scrollTo(0, 0)
      this.checkParams();
      let data = localStorageCustom.prototype.getUsuario();
      this.setState({ page: 1, file: {}, loading: false, dealer: data.dealer, linea: data.linea, asociado: data.asociado })
    } else
      window.location.href = "/";
  }

  switchPill = () => {
    if (this.state.pillActive == 0) {
      this.setState({ pillActive: 1 })
    } else {
      this.setState({ pillActive: 0 })
    }
  }

  render() {
    const { pillActive, productoReem, showDetails, showModalReemplazar, alertas, pedidoMasivo, loading, dataReemplazo } = this.state;
    // debugger;
    const auth = this.context;
    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="desktop">
          <div className="title_banner">
            <Container><h1>Pedido masivo</h1></Container>
            <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
          </div>
          <div className="breadcrumb">
            <Container>
              <ul>
                <li><Link to='/dashboard'>Dashboard</Link></li>
                <li>Pedidos</li>
                <li><Link to='/generar-pedido-masivo'>Generar Pedido masivo</Link></li>
                <li>Resultado</li>
              </ul>
            </Container>
          </div>
        </div>
        <Container className="py-5 container_pedido_masivo">
          <h6 className="title white mobile"><SvgAssets icon="icon-add-file" fill='#fff' />Pedido masivo</h6>
          <div className="card">
            <SvgAssets icon="curve-bottom" className='curve-top mobile' fill={'#1B52B2'} />
            <Pills dadComponent={this} />
            <p className="paragraph-1 text-center verde light">
              <strong className="bold">Se realizó</strong> la carga masiva de <strong className="bold">{pedidoMasivo.length}</strong> productos:
            </p>
            {(pedidoMasivo.filter(x => x.validaStok).length > 0) ?
              <div className='container-cards' style={{ backgroundColor: '#2DB997', flexDirection: pillActive == 0 ? 'column' : 'row' }}>
                {pillActive == 0 ?
                  <Row form className="header">
                    <Col xs={3} md={3}><span>Código</span></Col>
                    <Col xs={2} md={3} className="pr-0"><span>Cantidad</span></Col>
                    <Col xs={7} md={6}><span>Precio PVD</span></Col>
                  </Row> : null
                }
                <div className="cards-wrap w-100">
                  {pedidoMasivo.filter(x => x.validaStok).map((item, index) => {
                    return (
                      <Productos
                        producto={item}
                        key={index}
                        dadComponent={this} />
                    )
                  })}
                </div>
                <p className="total" style={{ maxWidth: pillActive == 0 ? 680 : 'initial' }}>Total: <strong>{pedidoMasivo[0].precioTotal}</strong></p>
              </div>
              : null}
            <h6 className="paragraph-1 rojo my-3 bold">Productos sin stock</h6>
            {(pedidoMasivo.filter(x => !x.validaStok).length > 0) ?
              <div className='container-cards' style={{ backgroundColor: '#F23361', flexDirection: pillActive == 0 ? 'column' : 'row' }}>
                {pillActive == 0 ?
                  <Row form className="header">
                    <Col xs={3} md={3}><span>Código</span></Col>
                    <Col xs={2} md={3} className="pr-0"><span>Cantidad</span></Col>
                    <Col xs={7} md={6}><span>Precio PVD</span></Col>
                  </Row> : null
                }
                <div className="cards-wrap">
                  {pedidoMasivo.filter(x => !x.validaStok).map((item, index) => {
                    return (
                      <ProductosSinStock
                        producto={item}
                        key={index}
                        dadComponent={this} />
                    )
                  })}
                </div>
              </div>
              : null}
            <hr className="desktop mx-5" style={{ borderColor: '#BDBDBD' }} />
            <div className="text-center mt-2">
              {/* <Link to="/dashboard" style={{ textDecoration: 'none' }}> */}
              <button className='btn-block'
                type="button"
                onClick={() => this.addPedidos(auth.carritoProdctos, auth.setcarritoProdctos)}
              >
                AGREGAR AL CARRITO<SvgAssets icon="icon-cart" fill="#fff" className='ml-2' />
              </button>
              {/* </Link> */}
            </div>
          </div>
        </Container>
        <ModalImageZoom dadComponent={this} />
        <ModalKit dadComponent={this} detalleKit={this.state.detalleKit} />
        <ModalReemplazo
          // {...dataReemplazo}
          modal={dataReemplazo}
          dadComponent={this}
          reemplazo={productoReem}
          auth={auth}
        />
      </div>
    );
  }

  postEliminarBuscador = async (index) => {
    let data = "";
    let ind = 1;
    var dataFilter = this.state.pedidoMasivo.filter(x => x.indice != index);
    dataFilter.map((prod) => {
      if (ind == dataFilter.length)
        data = data + `${prod.matnr}|${prod.cantidad}`
      else
        data = data + `${prod.matnr}|${prod.cantidad}&`

      ind++;
    })

    this.setState({
      loading: true
    })
    BuscarPedidoMasivo(this.state.dealer, this.state.linea, this.state.asociado, this.state.page, data, false)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            loading: false,
            pedidoMasivo: result.dto.repuestos,
            alertas: result.dto.alertas
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Alerta", error.message ?? null);
        });
      });
  }


  addPedidos(carritoProdctos, setcarritoProdctos) {
    this.setState({ loading: true });
    const correoElectronico = this.state.dealer.correoElectronico
    const codcliente = this.state.dealer.codcliente
    const centro = this.state.linea.centro
    const linea = this.state.linea.linea
    const vkorg = this.state.linea.vkorg
    const almacen = this.state.linea.almacen
    const canal = this.state.linea.canal
    const sector = this.state.linea.sector

    let ListaProductos = [];
    this.state.pedidoMasivo.filter(function (item) {
      ListaProductos.push({
        "CorreoElectronicoDealer": correoElectronico,
        "DispositivoDealer": null,
        "Descripcion": item.maktx,
        "CantidadOriginal": item.cantidad,
        "Moneda": item.waers,
        "Pantalla": data.Pantalla.BuscarMasivo.Producto,
        "Sustituto": null,
        "UnidadMedida": item.meins,
        "PrecioFinal": item.pfin,
        "Codigo": item.matnr,
        "CodigoDealer": codcliente,
        "Centro": centro,
        "Linea": linea,
        "Vkorg": vkorg,
        'Almacen': almacen,
        'Canal': canal,
        'Sector': sector
      });
    });

    AgregarNuevoProductoPedidoMasivo(ListaProductos)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false });
          // setcarritoProdctos(carritoProdctos + ListaProductos.length)
          setcarritoProdctos(result.dto.carritoProdctos);
          notificacion("Aviso", "Se agregaron productos al carrito");
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Detalle Pedidos", error.message ?? null);
        });
      });
  }
  postAgregarProductoFavorito = async (producto, AplicaFavorito, index) => {
    console.log(producto);
    this.setState({ loading: true })
    AgregarProductoFavorito(this.state.dealer, producto, this.state.linea, !AplicaFavorito
    )
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false })
          let _data = this.state.pedidoMasivo
          _data[index].favorito = !AplicaFavorito;
          this.setState({
            pedidoMasivo: _data
          })

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Alerta", error.message ?? null);
        });
      });
  }

  postAgregarProductoReemplazoFavorito = async (producto, AplicaFavorito, index) => {
    this.setState({ loading: true })
    AgregarProductoFavorito(this.state.dealer, producto, this.state.linea, !AplicaFavorito
    )
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false })
          // let _data = this.state.productoReem
          let _dataReemplazo = this.state.dataReemplazo
          let _data = _dataReemplazo.data
          _data[index].favorito = !AplicaFavorito;
          this.setState({
            dataReemplazo: {
              data: _data,
              isVisible: _dataReemplazo.isVisible,
              producto: _dataReemplazo.producto
            }
          })

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Reemplazo", error.message ?? null);
        });
      });
  }
  postBuscarKit = (dealer, linea, Matnr) => {
    this.setState({ loading: true })
    BuscarKit(dealer, linea, Matnr)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            detalleKit: result.dto.detalleKit,
            loading: false,
          })

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Alerta", error.message ?? null);
        });
      });
  }
  setCounterReemplazo = (counter, tab, index) => {
    let _data = this.state.dataReemplazo.data

    let _isVisible = this.state.dataReemplazo.isVisible
    let _producto = this.state.dataReemplazo.producto
    if (counter == "") {
      _data[index].cantidad = 0;
      _data[index].precioTotal = 0;
    } else {
      _data[index].cantidad = counter;
      _data[index].precioTotal = (counter * _data[index].pfin).toFixed(2);
    }
    this.setState({
      dataReemplazo: {
        data: _data,
        isVisible: _isVisible,
        producto: _producto
      }
    })
  }
  ejectarReemplazo = async () => {
    let data = "";
    let ind = 1;
    let dataFilter = this.state.pedidoMasivo;
    let productoReem = this.state.productoReem;
    for (var i = 0; i < dataFilter.length; i++) {
      if (productoReem.old != dataFilter[i].matnr)
        data = data + `${dataFilter[i].matnr}|${dataFilter[i].cantidad}&`
    }

    data = data + `${productoReem.matnr}|${productoReem.cantidad}`
    // dataFilter.map((prod) => {      
    //   if (ind == dataFilter.length) {
    //     if (productoReem.old == prod.matnr)
    //       data = data + `${productoReem.matnr}|${productoReem.cantidad}`
    //     else
    //       data = data + `${prod.matnr}|${prod.cantidad}`
    //   } else {
    //     if (productoReem.old == prod.matnr)
    //       data = data + `${productoReem.matnr}|${productoReem.cantidad}&`
    //     else
    //       data = data + `${prod.matnr}|${prod.cantidad}&`
    //   }
    //   ind++;
    // })

    console.log("data===>", data, productoReem);
    this.setState({
      loading: true
    })
    BuscarPedidoMasivo(this.state.dealer, this.state.linea, this.state.asociado, this.state.page, data, false)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            loading: false,
            pedidoMasivo: result.dto.repuestos,
            alertas: result.dto.alertas,
            dataReemplazo: {
              data: [],
              isVisible: false,
              producto: null
            }
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Alerta", error.message ?? null);
        });
      });


  }
  seleccionarReemplazo = async (value) => {

    this.setState({
      productoReem: { ...value, cantidadOriginal: 1, cantidad: 1 }
    })
  }
  CerrarReemplazo = async () => {
    this.setState({
      dataReemplazo: {
        data: [],
        isVisible: false,
        producto: null
      },
      productoReem: { cantidad: 0 }
    })
  }
  setCounter = (counter, tab, index) => {
    let _data = this.state.pedidoMasivo
    if (counter == "") {
      _data[index].cantidad = counter;
    } else {
      _data[index].cantidad = counter;
    }

    this.setState({
      pedidoMasivo: _data
    })

  }

  IrGeneradorPedidoMasivo = () => {
    this.props.navigation.navigate('GenerarPedidoMasivo');
  }
  switchCards = () => {
    this.setState(prevState => ({
      showDetails: !prevState.showDetails
    }));
  }


  MostrarReemplazo = async (prod) => {
    this.setState({
      loading: true
    })
    ListarMaterialSustituto(this.state.dealer, this.state.linea, this.state.asociado, prod.matnr, prod.cantidad)
      .then(result => {
        if (result.mo.type == "success") {
          result.dto.maerialSustituto.map((item) => {
            item.old = prod.matnr
          })

          this.setState({
            loading: false,
            dataReemplazo: {
              data: result.dto.maerialSustituto,
              isVisible: true,
              producto: prod
            }
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Buscador Masivo", error.message ?? null);
        });
      });


  }
}
